export let replyByImLabel = "dIz2Cc";
export let replyAllRecipientsByImLabel = "_oyYNb";
export let replyAllParticipantsByImLabel = "Yi8are";
export let replyByImDefaultLabel = "crcQfd";
export let replyByImWin32Label = "ir42j";
export let replyAllByImWin32Label = "Pdg4Ue";
export default {replyByImLabel,replyAllRecipientsByImLabel,replyAllParticipantsByImLabel,replyByImDefaultLabel,replyByImWin32Label,replyAllByImWin32Label};